// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__X_SeG","title":"FrontImage_title__2tXto"};